"use client"

import { TrainFront } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TrainFrontIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TrainFrontIcon = component(Icon)({ as: TrainFront })
